<script>
  import {onMount} from 'svelte';
  import {url} from '@sveltech/routify';

  import Loading from "../../Components/UI/Loading.svelte";
  import Error from "../../Components/UI/Error.svelte";
  import Boton from "../../Components/UI/Boton.svelte";
  import Titulo from "../../Components/UI/Titulo.svelte";
  import ParrillaDeMotivos from '../../Components/Motivos/Parrilla/index.svelte';

  import store from '../../Stores/motivos-store';
  import Modal from "../../Components/UI/Modal.svelte";
  import Icono from "../../Components/UI/Icono.svelte";

  onMount(() => store.cargar());
  $: error = $store.error;

  let motivoEliminado, errorEliminacion, motivos;
  $: motivoEliminado = $store.motivoEliminando;
  $: errorEliminacion = $store.errorEliminacion;

  const eliminarMotivo = e => store.eliminarTipo(e.detail);
  const eliminaMotivoDeVerdad = () => store.eliminaTipoDeVerdad(motivoEliminado);

  let activos = true;

  $: motivos = $store.listado;
</script>

<style>
    .nuevo-tipo {
        margin-top: var(--padding-global);
    }

    .filtro {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: var(--padding-global);
        letter-spacing: .15em;
    }

    label {
        margin-left: .5em;
    }

    label:not(:last-child) {
        margin-right: 1em;
    }
</style>

<svelte:head>
    <title>Motivos</title>
</svelte:head>

<Titulo>Motivos</Titulo>

{#if $store.cargando }
    <Loading/>
{/if}

{#if error}
    <Error on:cancel={() => error = false}>{$store.error}</Error>
{/if}

{#if motivos.length }
    <div>
        <ParrillaDeMotivos on:eliminar-motivo={eliminarMotivo} {motivos}/>

        <div class="nuevo-tipo">
            <Boton href="{$url('../nuevo')}">Nuevo motivo</Boton>
        </div>
    </div>
{/if}

{#if motivoEliminado}
    <Modal title="¿Está seguro de que desea eliminar el motivo {motivoEliminado.nombre}?"
           error={errorEliminacion}>
        <div slot="footer" class="opciones">
            <Boton on:click={eliminaMotivoDeVerdad} tipo="peligro">
                <Icono>check</Icono>
                Confirmar
            </Boton>
            <Boton on:click={() => motivoEliminado = false} tipo="neutral">
                <Icono>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}